import ApiEndpoint, { ApiResponse } from 'network/ApiEndpoint'

export const getLaunchPanelData = async (channelSlug: string) => {
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: `companies/${channelSlug}/launch_pannel`,
      authenticatable: true
    })
    const responseData = await resultResponse

    return responseData
  } catch (e: any) {
    // @ts-ignore
    throw new Error(e.message)
  }
}
